
















import { Component, Prop, Vue } from "vue-property-decorator";
import CzCard from "../cz/CzCard.vue";
import CzCover from "../cz/CzCover.vue";
import CzTag from "../cz/CzTag.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzChip from "../cz/CzChip.vue";
import CzIcon from "../cz/CzIcon.vue";

// One bookable service: photo on the left when it has one, otherwise text only.
@Component({ components: { CzCard, CzCover, CzTag, CzTitle, CzChip, CzIcon } })
export default class BookingTypeCard extends Vue {
  @Prop({ type: String, required: true }) to!: string;
  @Prop({ type: String, default: "" }) tag!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) price!: string;
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) goLabel!: string;

  get hasMore(): boolean {
    return (this.description || "").length > 80;
  }
}
